import { selectors } from 'modules/common';

import { XeroContactPerson } from '../../../data/xero/XeroContact';

export const getContacts = (contacts: XeroContactPerson[], me: selectors.types.ExpandedUser): XeroContactPerson[] => {
    return [
        {
            firstName: me.firstName,
            lastName: me.lastName,
            emailAddress: me.userEmail,
            includeInEmails: true,
        },
        ...contacts,
    ];
};
